import {
  FaTwitter,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";
import { useInfoProvider } from "../../context/InfoContext";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer = () => {
  const { info } = useInfoProvider();
  // useParticles("canvas");
  const links = [
    {
      name: "Contact Us",
      path: "/contact",
      content: null,
    },

    {
      name: "Refund & Cancellation Policy",
      path: "static-pages/refund-and-cancellation",
      // info?.page_list?.find(
      //   (e) => e?.page_slug === "refund-and-cancellation---"
      // )?.page_slug || "refund-and-cancellation",
    },
    {
      name: "Terms and Conditions",
      path: "static-pages/website-terms-of-use",
      //  +
      // (info?.page_list?.find((e) => e?.page_slug === "website-terms-of-use")
      //   ?.page_slug || "website-terms-of-use"),
    },
    {
      name: "Privacy Policy",
      path: "static-pages/common-privacy-policy",
      // +
      //   info?.page_list?.find((e) => e?.page_slug === "common-privacy-policy")
      //     ?.page_slug || "common-privacy-policy",
    },
  ];
  return (
    <>
      {" "}
      {/* <canvas id="canvas" style={{ width: "100%", height: "100vh" }} /> */}
      <footer className="relative bg-gray-900 text-white pt-16 pb-12 px-6 md:px-16 overflow-hidden">
        {/* Background patterns */}
        <div className="absolute inset-0 overflow-hidden opacity-10">
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="relative w-full h-full">
              {[...Array(50)].map((_, i) => (
                <div
                  key={i}
                  className="absolute rounded-full bg-white"
                  style={{
                    width: `${Math.random() * 6 + 2}px`,
                    height: `${Math.random() * 6 + 2}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    opacity: Math.random() * 0.5 + 0.3,
                  }}
                />
              ))}
            </div>
          </div>
          <div className="absolute -right-32 -top-32 w-64 h-64 rounded-full bg-blue-600 opacity-10 blur-xl"></div>
          <div className="absolute -left-32 -bottom-32 w-64 h-64 rounded-full bg-purple-600 opacity-10 blur-xl"></div>
        </div>

        <div className="container mx-auto relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img src="/logo.png" alt="Logo" className="h-12" />
                <span className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                  GIGSAM
                </span>
              </div>
              <p className="text-gray-400 mb-6 leading-relaxed">
                Whether you're looking for flexible part-time work or top talent
                for full-time employment, we've got you covered.
              </p>
              <div className="flex space-x-3">
                {info?.twitter_link && (
                  <a
                    href={info?.twitter_link}
                    target="_blank"
                    className="bg-gray-800 hover:bg-blue-600 p-3 rounded-full transition-all duration-300 hover:-translate-y-1"
                  >
                    <FaXTwitter className="text-white text-lg" />
                  </a>
                )}
                {info?.facebook_link && (
                  <a
                    href={info?.facebook_link}
                    target="_blank"
                    className="bg-gray-800 hover:bg-blue-600 p-3 rounded-full transition-all duration-300 hover:-translate-y-1"
                  >
                    <FaFacebookF className="text-white text-lg" />
                  </a>
                )}
                {info?.instagram_link && (
                  <a
                    href={info?.instagram_link}
                    target="_blank"
                    className="bg-gray-800 hover:bg-pink-500 p-3 rounded-full transition-all duration-300 hover:-translate-y-1"
                  >
                    <FaInstagram className="text-white text-lg" />
                  </a>
                )}
                {info?.youtube_link && (
                  <a
                    href={info?.youtube_link}
                    target="_blank"
                    className="bg-gray-800 hover:bg-red-500 p-3 rounded-full transition-all duration-300 hover:-translate-y-1"
                  >
                    <FaYoutube className="text-white text-lg" />
                  </a>
                )}
                {info?.linkedinurl && (
                  <a
                    href={info?.linkedinurl}
                    target="_blank"
                    className="bg-gray-800 hover:bg-blue-300 p-3 rounded-full transition-all duration-300 hover:-translate-y-1"
                  >
                    <FaLinkedinIn className="text-white text-lg" />
                  </a>
                )}
              </div>
            </div>

            {/* Important Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <span className="w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
                Important Links
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={{
                        pathname: link.path,
                      }}
                      className="text-gray-400 hover:text-white flex items-center transition-colors duration-300 group"
                    >
                      <HiArrowRight className="text-blue-500 opacity-0 group-hover:opacity-100 mr-2 transition-opacity duration-300" />
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <span className="w-3 h-3 bg-purple-500 rounded-full mr-2"></span>
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  {
                    name: "Our Services",
                    link: "/service",
                  },
                  {
                    name: "About Us",
                    link: "/about",
                  },
                ].map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link?.link}
                      className="text-gray-400 hover:text-white flex items-center transition-colors duration-300 group"
                    >
                      <HiArrowRight className="text-purple-500 opacity-0 group-hover:opacity-100 mr-2 transition-opacity duration-300" />
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-6 flex items-center">
                <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
                Contact Info
              </h4>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start">
                  <div className="bg-blue-600 p-3 rounded-full mr-3">
                    <FaWhatsapp className="text-white text-base" />
                  </div>
                  <span className="text-gray-400 hover:text-white transition-colors duration-300">
                    {info?.app_contact}
                  </span>
                </li>
                <li className="flex items-start">
                  <div className="bg-purple-600 p-3 rounded-full mr-3">
                    <FaEnvelope className="text-white text-base" />
                  </div>
                  <span className="text-gray-400 hover:text-white transition-colors duration-300">
                    {info?.app_email || "info@gigsam.com"}
                  </span>
                </li>
                {/* <li className="flex items-start">
                  <div className="bg-green-600 p-3 rounded-full mr-3">
                    <FaMapMarkerAlt className="text-white text-base" />
                  </div>
                  <span className="text-gray-400 hover:text-white transition-colors duration-300">
                    7232 Broadway Suite 308, Jackson Heights, 11372, NY, United
                    States
                  </span>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* Copyright */}
      <div className="relative bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6 md:px-16">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between text-sm">
          <div className="text-center md:text-left mb-2 md:mb-0">
            © 2025 GIGSAM – Fast. Reliable. Workforce Solutions.
          </div>
          <div className="flex space-x-4 justify-center md:justify-end">
            <Link
              to={{
                pathname: "static-pages/website-terms-of-use",
              }}
              className="hover:text-blue-200 transition"
            >
              Terms of Use
            </Link>
            <span>|</span>
            <Link
              to={{
                pathname: "static-pages/common-privacy-policy",
              }}
              className="hover:text-blue-200 transition"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
